import * as React from 'react';
import {ButtonBrand, gold, TypographyBrand, white, } from '../../../../getLPTheme';
import 'react-multi-carousel/lib/styles.css';
import { Box, Button, Card, CardActionArea, CardMedia, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';


// Genero una base de datos Ficticia
function createArray(
    id: number,
    img: string,
    link: string,
    text: string,
  ) {
    return { id, img, link, text};
  }
  
  const myArray = [
    createArray(
      1,
      'https://club-vip-media.s3.amazonaws.com/landing-page/landing-carousel/campos-de-golf2.png',
      'categoria/club',
      'Los mejores campos de Golf de la Argentina te están esperando'
      
    ),
    createArray(
      2,
      'https://club-vip-media.s3.amazonaws.com/landing-page/landing-carousel/hoteles-y-restaurantes.png',
      'categoria/hotel',
      'Ahorrá vayas a donde vayas.'
    ),
    createArray(
      3,
      'https://club-vip-media.s3.amazonaws.com/landing-page/landing-carousel/tiendas1.png',
      'categoria/proshop',
      'Descuentos exclusivos en marcas líderes de accesorios y ropa de golf'
    ),
    createArray(
      4,
      'https://club-vip-media.s3.amazonaws.com/landing-page/landing-carousel/golf-exclusivos.png',
      'categoria/club',
      'Oportunidades únicas para jugar en campos de golf exclusivos y de prestigio'
    ),
    createArray(
      5,
      'https://club-vip-media.s3.amazonaws.com/landing-page/landing-carousel/turismo2.png',
      'categoria/turismo',
      'Viajá a jugar a precios increibles'
    ),
    createArray(
      6,
      'https://club-vip-media.s3.amazonaws.com/landing-page/landing-carousel/torneos6.png',
      'categoria/torneo',
      'Participá en torneos exclusivos organizados por WGC, sólo para miembros'
    ),
    createArray(
      7,
      'https://club-vip-media.s3.amazonaws.com/landing-page/landing-carousel/golf-exclusivos2.png',
      'categoria/otro',
      'Otros Beneficios'
    ),       
  ];

  export default function Carouseles({items}) {

    const [selectedIndex1, setSelectedIndex1] = useState(0);
    const [selectedCardImg1, setSelectedCardImg1] = useState(myArray[0].img);
    const [selectedCardImg2, setSelectedCardImg2] = useState(myArray[1].img);
    const [selectedCardImg3, setSelectedCardImg3] = useState(myArray[2].img);
    const [selectedCardLink1, setSelectedCardLink1] = useState(myArray[0].link);
    const [selectedCardLink2, setSelectedCardLink2] = useState(myArray[1].link);
    const [selectedCardLink3, setSelectedCardLink3] = useState(myArray[2].link);
    const [selectedCardText1, setSelectedCardText1] = useState(myArray[0].text);
    const [selectedCardText2, setSelectedCardText2] = useState(myArray[1].text);
    const [selectedCardText3, setSelectedCardText3] = useState(myArray[2].text);
    const [loaded, setLoaded] = useState(false);


    const [selectedIndex, setSelectedIndex] = useState(0);
    const [selectedCardImg, setSelectedCardImg] = useState(myArray[0].img);
    const [selectedCardText, setSelectedCardText] = useState(myArray[0].text);
    const [selectedCardLink, setSelectedCardLink] = useState(myArray[0].link);
  
  
    const selectNewCard = (index: number, myArray: Array<any>, next = true) => {
      setLoaded(false);

      setTimeout(() => {

        const condition = next ? (selectedIndex1 < 4) : (selectedIndex1 > 0);
        const nextIndex1 = next ? (condition ? (selectedIndex1 === 3 ? selectedIndex1 + 1 : selectedIndex1 + 3) : 0) : (condition ? (selectedIndex1=== 1 ? selectedIndex1 - 1 : selectedIndex1 - 3) : myArray.length - 3);
        const nextIndex2 = nextIndex1 + 1
        const nextIndex3 = nextIndex1 + 2

        setSelectedCardImg1(myArray[nextIndex1].img);
        setSelectedCardImg2(myArray[nextIndex2].img);
        setSelectedCardImg3(myArray[nextIndex3].img);

        setSelectedCardLink1(myArray[nextIndex1].link);
        setSelectedCardLink2(myArray[nextIndex2].link);
        setSelectedCardLink3(myArray[nextIndex3].link);

        setSelectedCardText1(myArray[nextIndex1].text);
        setSelectedCardText2(myArray[nextIndex2].text);
        setSelectedCardText3(myArray[nextIndex3].text);

        setSelectedIndex1(nextIndex1);

      }, 500);
    };
  
    const previous = () => {
      selectNewCard(selectedIndex1, myArray, false);  // Le digo que next = false
    };
  
    const next = () => {
      selectNewCard(selectedIndex1, myArray);  // por default Next = true
    };


    const selectNewCardPhone = (index: number, myArray: Array<any>, next = true) => {
      setLoaded(false);
      
      setTimeout(() => {
        const condition = next ? selectedIndex < myArray.length - 1 : selectedIndex > 0;
        const nextIndex = next ? (condition ? selectedIndex + 1 : 0) : condition ? selectedIndex - 1 : myArray.length - 1;
        setSelectedCardImg(myArray[nextIndex].img);
        setSelectedCardLink(myArray[nextIndex].link);
        setSelectedCardText(myArray[nextIndex].text);
        setSelectedIndex(nextIndex);

      }, 1000);
    };


    const previousPhone = () => {
      selectNewCardPhone(selectedIndex, myArray, false);  // Le digo que next = false
    };
  
    const nextPhone = () => {
      selectNewCardPhone(selectedIndex, myArray);  // por default Next = true
    };


  
    return (
      <Box>
        {/* Aca establezco que si es pantalla chica no muestre este formato.  */}
        <Box sx={{display: {xs: "none", md: "flex", sm:"flex"}, alignItems: "center", justifyContent: "center", direction: "row" }}>
          <Box sx={{ paddingRight:2,}}>
            <ButtonBrand onClick={previous}>{<ArrowBackIosIcon/>}</ButtonBrand>
          </Box>
          <Box sx={{ position: 'relative' }}>
            <Card sx={{width: {xs: 350, sm: 400}, p:1, m:1, transition: "0.2s","&:hover": {transform: "scale(1.02)",},}}>
              <CardActionArea href={selectedCardLink1} >
                  <CardMedia component="img" image={selectedCardImg1} height="400" alt="Card Image" sx={{opacity: 0.5}}/>
                  <Box sx={{position: 'absolute',top: "0%",height: 400, left: 0,width: '100%',color: 'white',padding: '5px',direction:"column", justifyContent:"center", alignItems:"flex-start", display: "grid"}}>
                    <TypographyBrand sx={{m:1,fontSize: {xl: "2vw", lg: "2vw", md: "2vw", sm:"2vw", xs:"4vw"}}}>
                        {selectedCardText1}
                    </TypographyBrand>
                  </Box>
              </CardActionArea>
            </Card>
          </Box>

          <Box sx={{ position: 'relative' }}>
            <Card sx={{width: {xs: 350, sm: 400}, p:1, m:1, transition: "0.2s","&:hover": {transform: "scale(1.02)",},}}>
              <CardActionArea href={selectedCardLink2} >
                <CardMedia component="img" image={selectedCardImg2} height="400" alt="Card Image" sx={{opacity: 0.5}}/>
                <Box sx={{position: 'absolute',top: "0%",height: 400, left: 0,width: '100%',color: 'white',padding: '5px',direction:"column", justifyContent:"center", alignItems:"flex-start", display: "grid"}}>
                  <TypographyBrand sx={{m:1,fontSize: {xl: "2vw", lg: "2vw", md: "2vw", sm:"2vw", xs:"4vw"}}}>
                      {selectedCardText2}
                  </TypographyBrand>
                </Box>               
              </CardActionArea>
            </Card>
          </Box>

          <Box sx={{ position: 'relative' }}>
            <Card sx={{width: {xs: 350, sm: 400}, p:1, m:1, transition: "0.2s","&:hover": {transform: "scale(1.02)",},}}>
              <CardActionArea href={selectedCardLink3} >
                <CardMedia component="img" image={selectedCardImg3} height="400" alt="Card Image" sx={{opacity: 0.5}}/>
                <Box sx={{position: 'absolute',top: "0%",height: 400, left: 0,width: '100%',color: 'white',padding: '5px',direction:"column", justifyContent:"center", alignItems:"flex-start", display: "grid"}}>
                  <TypographyBrand sx={{m:1, fontSize: {xl: "2vw", lg: "2vw", md: "2vw", sm:"2vw", xs:"4vw"}}}>
                      {selectedCardText3}
                  </TypographyBrand>
                </Box>                  
              </CardActionArea>
            </Card>
          </Box>
          <Box sx={{paddingLeft:2, }}>
            <ButtonBrand onClick={next}>{<ArrowForwardIosIcon/>}</ButtonBrand> 
          </Box>
        </Box>

        {/* Aca establezco que si es pantalla Grande no muestre este formato.  */}

        <Box sx={{display: {xs: "grid", md: "none", sm:"none"}, alignItems: "center", justifyContent: "center", direction: "row" }}>
          <Box sx={{ }}>
            <Card sx={{width: "23rem", p:1, m:1, transition: "0.2s","&:hover": {transform: "scale(1.02)",},}}>
              <CardActionArea href={selectedCardLink} >
                  <CardMedia component="img" image={selectedCardImg} height="400" alt="Card Image" sx={{opacity: 0.5}}/>
                  <Box sx={{position: 'absolute',top: "0%",height: 400, left: 0,width: '100%',color: 'white',padding: '5px',direction:"column", justifyContent:"center", alignItems:"flex-start", display: "grid"}}>
                    <TypographyBrand sx={{m:1,fontSize: {xl: "2vw", lg: "2vw", md: "2vw", sm:"2vw", xs:"6vw"}}}>
                        {selectedCardText}
                    </TypographyBrand>
                  </Box>
              </CardActionArea>
            </Card>
          </Box>
          <Box sx={{pt:2, display: 'flex',alignItems: "center", justifyContent: "center", direction: "row"}}>
            <Box sx={{ paddingRight:2, width: '40%'}}>
              <ButtonBrand sx={{width: 100}} onClick={previousPhone}>{<ArrowBackIosIcon/>}</ButtonBrand>
            </Box>
            <Box sx={{paddingLeft:2, width: '40%'}}>
              <ButtonBrand sx={{width: 100}} onClick={nextPhone}>{<ArrowForwardIosIcon/>}</ButtonBrand> 
            </Box>
          </Box>
        </Box>
      </Box>
    );
}